import Layout from "../../components/layout/Layout"
import { Helmet } from 'react-helmet';

const PrivacyPolicyRU = () => {
    return (
        <div >
            <Helmet>
                <meta name="description" content="Privacy Policy" />
            </Helmet>
            <div className="container" style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 30 }}>
                <h2>Политика конфиденциальности</h2>
                <p>Мы, Общество с ограниченной ответственностью “САНПОИНТ АЙ-ТИ СОЛЮШНС”, код ЕГРПОУ 42783354, в соответствии с Законом Украины от 01 июня 2010 года № 2297-VI «О защите персональных данных» (далее – «Закон»), обязуемся обеспечивать конфиденциальность ваших персональных данных. Под персональными данными понимаются сведения, которые позволяют идентифицировать вас, такие как имя, фамилия, электронная почта, номер телефона и другие сведения, которые вы добровольно предоставляете нам.</p>

                <p>Компания с большим уважением относится к конфиденциальной (персональной) информации всех пользователей, которые посетили наш сайт и используют предоставляемые платформой услуги. В связи с этим, Компания стремится защищать конфиденциальность персональных данных, обеспечивая максимально комфортные условия использования сервисов платформы для каждого пользователя.</p>

                <p>Эта Политика конфиденциальности описывает, как мы собираем, используем и защищаем вашу личную информацию при использовании нашей платформы SkTech (далее — «Платформа»). Используя нашу Платформу, вы соглашаетесь с условиями этой Политики конфиденциальности.</p>

                <h3>1. Сбор и использование персональных данных</h3>
                <ol>
                    <li>
                        <p>Платформа собирает следующие данные:</p>
                        <ul>
                            <li>Имя, фамилия, электронная почта, номер телефона;</li>
                            <li>Информация, предоставленная пользователем добровольно (при регистрации, запросах).</li>
                        </ul>
                    </li>
                    <li>
                        <p>Цели обработки данных:</p>
                        <ul>
                            <li>Предоставление доступа к сервису;</li>
                            <li>Техническая поддержка;</li>
                            <li>Информирование о новостях и обновлениях;</li>
                            <li>Аналитика для улучшения качества услуг.</li>
                        </ul>
                    </li>
                </ol>

                <h3>2. Защита и хранение данных</h3>
                <ol>
                    <li>Платформа обеспечивает должный уровень защиты персональных данных пользователей от несанкционированного доступа, потери или изменения.</li>
                    <li>Срок хранения: до момента удаления профиля пользователя или прекращения работы Платформы.</li>
                </ol>

                <h3>3. Раскрытие персональных данных</h3>
                <ol>
                    <li>
                        Платформа не передает персональные данные третьим лицам, за исключением случаев, когда данные могут быть переданы:
                        <ul>
                            <li>Платежным системам для выполнения транзакций;</li>
                            <li>Партнерам для обслуживания Платформы;</li>
                            <li>Уполномоченным органам в соответствии с законодательством Украины.</li>
                        </ul>
                    </li>
                </ol>

                <h3>4. Использование файлов cookie</h3>
                <ol>
                    <li>Файлы cookie используются для сохранения настроек пользователя, анализа трафика, улучшения работы Платформы.</li>
                    <li>Пользователь может отказаться от cookies в настройках браузера, но это может ограничить функциональность.</li>
                </ol>

                <h3>5. Права пользователей</h3>
                <ol>
                    <li>
                        Пользователь имеет право:
                        <ul>
                            <li>На доступ к своим данным и их изменение;</li>
                            <li>На ограничение обработки или удаление данных;</li>
                            <li>Запросы подаются через контактную информацию, указанную ниже.</li>
                        </ul>
                    </li>
                </ol>

                <h3>6. Изменения в Политике</h3>
                <p>Платформа оставляет за собой право изменять Политику. Обновления публикуются с датой вступления в силу. Продолжение использования Платформы означает принятие изменений.</p>

                <h3>7. Контактная информация</h3>
                <p>ООО “САНПОИНТ АЙ-ТИ СОЛЮШНС”<br />
                    Код ЕГРПОУ: 42783354<br />
                    Адрес: ул. Серповая 11, Киев, Украина<br />
                    Email: sktech@sunpoint.com.ua</p>

                <p>Дата последнего обновления: 27.11.2024</p>
            </div>
        </div>
    )
}
export default PrivacyPolicyRU;